import type { CertsyAnalytics } from 'src/modules/analytics/certsy';
import type { CertsyAction } from 'src/modules/analytics/certsy/actionCreators';
import type { Action } from 'src/types';

import { instrumentAnalytics } from '../analyticsMiddlewareUtils';

export const createCertsyAnalyticsMiddleware = (analytics: CertsyAnalytics) =>
  instrumentAnalytics(analytics) &&
  (() => (next: (action: Action) => void) => (action: CertsyAction) => {
    const { certsyLinkClicked } = analytics;

    switch (action.type) {
      case 'CERTSY_LINK_CLICKED': {
        const {
          credentialType,
          linkAction,
          linkPosition,
          linkUrl,
          currentPageSection,
          certsyStatus,
        } = action.payload;

        certsyLinkClicked({
          credentialType,
          linkAction,
          linkPosition,
          currentPageSection,
          urlLink: linkUrl,
          certsyStatus,
        });

        break;
      }

      default: {
        break;
      }
    }

    return next(action);
  });
